/*
 * File: cell-select.ts
 * File Created: 2024-03-09 09:54:40
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import { Component, Prop } from "vue-property-decorator";

@Component
@UITag.setDefault({
    uiSort: true,
    uiSearch: true,
})
export default class CellSelect extends BaseTableBodyCell {
    /// name / value pair of the select / options
    @Prop({ type: Object, default: () => ({}) })
    options!: any;

    /// private helpers
    get generatedReversedOptions() {
        return this.options;
        // return Object.keys(this.options).reduce((final, name) => {
        //     final[this.options[name]] = name;
        //     return final;
        // }, {});
    }
}
